/**
 * Not every theme needs new recaptcha actions. However, if a theme/customization significantly alters the structure
 * of the page (like legacy vs progressive), then a new recaptcha action for that theme should be added for
 * all pages that use recaptcha.
 *
 * If you add a new recaptcha action, please make sure to add the corresponding action in the backend.
 */
export const SIGNIN_ACTIONS: RecaptchaActionsType = {
  legacy: 'iesLegacySignin',
  default: 'iesSignin',
};

export const AUTOLOGIN_ACTIONS: RecaptchaActionsType = {
  legacy: 'iesAutoLogin',
  default: 'iesLegacyAutoLogin',
};

export const ADD_MOBILE_PHONE_ACTIONS: RecaptchaActionsType = {
  legacy: 'iesLegacySendMobileVerificationCode',
  default: 'iesSendMobileVerificationCode',
};

export const AUO_WELCOME_ACTIONS: RecaptchaActionsType = {
  legacy: 'iesLegacyAuoWelcome',
  default: 'iesAuoWelcome',
};

export const AUO_WELCOME_INSTRUCTOR_ACTIONS: RecaptchaActionsType = {
  legacy: 'iesLegacyAuoWelcomeInstructor',
  default: 'iesAuoWelcomeInstructor',
};

export const AUTO_LOGIN_ACTIONS: RecaptchaActionsType = {
  legacy: 'iesLegacyAutoLogin',
  default: 'iesAutoLogin',
};

export const CREATE_ACCOUNT_ACTIONS: RecaptchaActionsType = {
  legacy: 'iesLegacyCreateAccount',
  default: 'iesCreateAccount',
};

export const CREATE_AND_LINK_ACCOUNT_ACTIONS: RecaptchaActionsType = {
  legacy: 'iesLegacyCreateAndLinkAccount',
  default: 'iesCreateAndLinkAccount',
};

export const AUO_CREATE_PASSWORD_ACTIONS: RecaptchaActionsType = {
  legacy: 'iesLegacyAUOCreatePassword',
  default: 'iesAUOCreatePassword',
};

export const FORGOT_UN_PW_EMAIL_ACTIONS: RecaptchaActionsType = {
  legacy: 'iesLegacyForgotUnPwEmail',
  default: 'iesForgotUnPwEmail',
};

export const FORGOT_UN_PW_MOBILE_ACTIONS: RecaptchaActionsType = {
  legacy: 'iesLegacySendMobileVerificationCode',
  default: 'iesSendMobileVerificationCode',
};

export const VERIFY_MOBILE_PHONE_ACTIONS: RecaptchaActionsType = {
  legacy: 'iesLegacyVerifyAddPhoneCode',
  default: 'iesVerifyAddPhoneCode',
};

export const SEND_MOBILE_VERIFICATION_CODE_ACTIONS: RecaptchaActionsType = {
  legacy: 'iesLegacySendMobileVerificationCode',
  default: 'iesSendMobileVerificationCode',
};

export const VERIFY_PHONE_CODE_ACTIONS: RecaptchaActionsType = {
  legacy: 'iesLegacyVerifyForgotUnPwdPhoneCode',
  default: 'iesVerifyForgotUnPwdPhoneCode',
};

export const LINK_ACCOUNT_ACTIONS: RecaptchaActionsType = {
  legacy: 'iesLegacyLinkAccounts',
  default: 'iesLinkAccounts',
};

export const ACCOUNT_MGMT_INFO_ACTIONS = {
  legacy: 'iesLegacyAcctInfo',
  default: 'iesAcctInfo',
};

export const SIGNIN_WITH_CODE_ESCROW_ACTIONS: RecaptchaActionsType = {
  legacy: 'iesLegacySignInWithCodeEscrow',
  default: 'iesSignInWithCodeEscrow',
};

export const SIGNIN_WITH_CODE_SIGNIN_ACTIONS: RecaptchaActionsType = {
  legacy: 'iesLegacySignInWithCodeSignin',
  default: 'iesSignInWithCodeSignin',
};

export const CHECK_EMAIL_AVAILABILITY_ACTIONS: RecaptchaActionsType = {
  legacy: 'iesLegacyCheckEmailAvailability',
  default: 'iesCheckEmailAvailability',
};
